const getTranslation = (selectedLanguage, keyword) => {
    const translations = {
        Español: {
            leadGenFormHeader: "Obtén las últimas ofertas y actualizaciones.",
            leadGenFieldName: "Dirección de correo electrónico",
            leadGenPrivacyStatement: 'Al proporcionar mi información de contacto, acepto que la información que proporcioné pueda usarse en el proceso de donación. Para obtener más información sobre cómo BioLife procesa mi información personal, puedo consultar <a href="/privacy-notice?lng=es-MX&origin=chatbot" target="_blank">el Aviso de Privacidad de BioLife</a>.',
            leadGenPrivacy2ndStatement: 'Para cambiar mis preferencias de comunicación, puedo iniciar sesión en mi cuenta e ir a mi Configuración.',
            leadGenSubmit: "Enviar y Continuar al Chat",
            leadGenReturn: "Regresar al Chat",
            leadGenSuccessFormHeader: "¡Todo listo!",
            leadGenSuccessFormDesc: "Mantén un ojo en tu bandeja de entrada. Pronto te enviaremos información útil sobre la donación de plasma",
            leadGenSuccessFormContinue: "Continuar chat",
            leadGenFirstNameFieldName: "Nombre",
            leadGenLastNameFieldName: "Apellido",
            leadGenZipCodeFieldName: "Código postal",
            leadGenFirstNameShouldHaveAtLeasst1Char: "El nombre debe tener al menos 1 letra",
            leadGenFirstNameShouldBeCharacteterOnly: "El nombre debe contener únicamente letras",
            leadGenfirstNameIsRequired: "El nombre es orequerido",
            leadGenLastNameShouldHaveAtLeast2Char: "El apellido debe tener al menos 2 letras",
            leadGenLastNameShouldBeCharacter: "El apellido debe contener únicamente letras",
            leadGenLastNameIsRequired: "El apellido es requerido",
            leadGenChatbotEmailAddressMustBeInValid: "El correo electrónico debe tener un formato válido",
            pleaseEnterANonEmployeeEmail: "Escriba una dirección de correo electrónico que no sea de empleado",
            emailAddressIsRequired: "Se requiere una dirección de correo electrónico",
            zipCodeShouldHave5Digits: "El código postal debe ser de 5 dígitos",
            zipCodeIsRequired: "Se requiere un código postal",
        },
        English: {
            leadGenFormHeader: "Get the latest offers and updates.",
            leadGenPrivacyStatement: 'By providing my contact information, I agree that the information I provided may be used in the donation process. For more information on how BioLife processes my personal information I can go to the BioLife <a href="/privacy-notice?origin=chatbot" target="_blank">Privacy Notice.</a>',
            leadGenPrivacy2ndStatement: 'To change my communication preferences I can log into my account and go to my Settings.',
            leadGenSubmit: "Submit & Continue Chat",
            leadGenReturn: "Return To Chat",
            leadGenSuccessFormHeader: "You are all set!",
            leadGenSuccessFormDesc: "Keep an eye on your inbox—we’ll be sending you helpful info about plasma donation soon.",
            leadGenSuccessFormContinue: "Continue Chat",
            leadGenFieldName: "Email Address",
            leadGenFirstNameFieldName: "First Name",
            leadGenLastNameFieldName: "Last Name",
            leadGenZipCodeFieldName: "Zip Code",
            leadGenFirstNameShouldHaveAtLeasst1Char: "First Name should have at least 1 character",
            leadGenFirstNameShouldBeCharacteterOnly: "First Name should be characters only",
            leadGenfirstNameIsRequired: "First Name is required",
            leadGenLastNameShouldHaveAtLeast2Char: "Last Name should have at least 2 characters",
            leadGenLastNameShouldBeCharacter: "Last Name should be characters only",
            leadGenLastNameIsRequired: "Last Name is required",
            leadGenChatbotEmailAddressMustBeInValid: "Email address must be in valid email format",
            pleaseEnterANonEmployeeEmail: "Please enter a non-employee email address",
            emailAddressIsRequired: "Email address is required",
            zipCodeShouldHave5Digits: "Zip code should have 5 digits",
            zipCodeIsRequired: "Zip Code is required",
        }
    };

    if (!translations[selectedLanguage]) {
        throw new Error(`Unsupported language: ${selectedLanguage}`);
    }

    return translations[selectedLanguage][keyword] || keyword;
};

export default getTranslation;